module.exports = __webpack_public_path__ + "img/BJ.2f8ccc90.svg";